import emailMixin from '@/mixins/emailMixin';
import config from '@/common/config'; 

export default {
    mixins: [emailMixin],
    methods: {
        $_getEmailMeta(loggedInEmployee, positionTemplate) {
            const link = `${config.APP_URL}positionTemplate/${positionTemplate.id}`;
            const body = `<p>Here is a link to the Position <a href="${link}" target="_blank">${positionTemplate.title}</a>.</p>${this.$_getEmployeeEmailSignature(loggedInEmployee)}`
            const subject = `Position - ${positionTemplate.title}`
            return { subject, body }
        }
    }
}